(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["firemate-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('cart:update', (event) => {
    const data = event.detail?.data;
    const cartLink = document.querySelector('.fm-cart-link');
    if (!data || !cartLink || data.didError) return;
    if (data.source === 'product-form-component') {
      window.location.assign(cartLink.href);
      return;
    }
    if (typeof data.itemCount === 'number') {
      const count = cartLink.querySelector('[data-fm-cart-count]');
      if (count) count.textContent = String(data.itemCount);
      cartLink.setAttribute('aria-label', cartLink.dataset.cartLabel.replace('__COUNT__', String(data.itemCount)));
    }
  });
  document.addEventListener('click', (event) => {
    if (event.target.closest('.fm-mobile-menu a')) {
      const menu = event.target.closest('.fm-mobile-menu');
      menu.open = false;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
